import { TRIGGER_HOVER, CLEAR_HOVER } from './constants';

const initialState = {
    hoveredDeviceId: null,
};

const animationReducer = (state = initialState, action) => {
    switch (action.type) {
        case TRIGGER_HOVER:
            return {
                ...state,
                hoveredDeviceId: action.payload,
            };
        case CLEAR_HOVER:
            return {
                ...state,
                hoveredDeviceId: null,
            };
        default:
            return state;
    }
};

export default animationReducer;
